// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ncWd","importantInfo":"styles_importantInfo__2ys2u"};